import { StylesProvider } from "@material-ui/core/styles";
import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Footer, Header } from "./components";
import CreateDeckScreen from "./screens/CreateDeckScreen";
import EditDeckScreen from "./screens/EditDeckScreen";
import DeregisterScreen from "./screens/DeregisterScreen";
import LoginRoute from "./screens/LoginRoute";
import LoginScreen from "./screens/LoginScreen";
import ProtectedRoute from "./screens/PrivateRoute";
import QuestionsScreen from "./screens/QuestionsScreen";
import SingleQuestionsScreen from "./screens/SingleQuestionsScreen";
import CompletedTestScreen from "./screens/completedTestScreen";
import SplashScreen from "./screens/SplashScreen";
import { TestScreen } from "./screens/TestScreen";
import { RedirectScreen } from "./screens/RedirectScreen";
import DeckListScreen from "./screens/DeckListScreen";
import NoteListScreen from "./screens/NoteListScreen";
import ViewDeckScreen from "./screens/ViewDeckScreen";
import ViewMessageScreen from "./screens/ViewMessageScreen";
import { PublicDecksScreen } from "./screens/PublicDecksScreen";
import { HomeScreen } from "./screens/HomeScreen";
import { ErrorScreen } from "./screens/ErrorScreen";
import { ProfileScreen } from "./screens/ProfileScreen";
import { SettingsScreen } from "./screens/SettingsScreen";
import { LeaderBoardScreen } from "./screens/LeaderBoardScreen";
import { NotificationsScreen } from "./screens/NotificationsScreen"; 
import { CMEInfoScreen } from "./screens/CMEInfoScreen";
import { CMERedirectScreen } from "./screens/CMERedirectScreen";
import FlashCardsScreen from "./screens/FlashCardsScreen";
import FlashCardReviewScreen from "./screens/FlashCardReviewScreen";
import { AnimatePresence } from 'framer-motion';
import QuestionTestScreen from "./screens/QuestionTestScreen";
import { ProgramScreen } from "./screens/ProgramScreen";
import { ResidentScreen } from "./screens/ResidentScreen";
import QuizScreen from "./screens/QuizScreen";
import QuizResultScreen from "./screens/QuizResultScreen";
import QuizListAllScreen from "./screens/QuizListAllScreen";
import QuizListScreen from "./screens/QuizListScreen";  

import "./styles/globalStyles.css";

//TODO change question screen to protected route

class Routes extends React.Component {
    componentDidMount = async () => {
        
    }
    render() {
        return (
            <StylesProvider injectFirst>
                <Router>
                    <Header 
                        test={'testing props'}
                        history={this.props.history}
                    />
                    <AnimatePresence timeout={300} classNames="page-transition">
                        <Switch> 
                            <Route exact path="/" component={RedirectScreen} />
                            <LoginRoute path="/login" component={LoginScreen} />
                            <LoginRoute path="/deregister" component={DeregisterScreen} />
                            <ProtectedRoute path="/splash" component={SplashScreen} />
                            <ProtectedRoute path="/home" component={HomeScreen} />
                            <ProtectedRoute path="/myDecks" component={DeckListScreen} />
                            <ProtectedRoute path="/cmeinfo" component={CMEInfoScreen} />
                            <ProtectedRoute path="/cmeredirect" component={CMERedirectScreen} />
                            <ProtectedRoute path="/myFlashCards" component={FlashCardsScreen} />
                            <ProtectedRoute path="/showFlashCard" component={FlashCardReviewScreen} />
                            <ProtectedRoute path="/myNotes" component={NoteListScreen} />
                            <ProtectedRoute path="/profile" component={ProfileScreen} />
                            <ProtectedRoute path="/settings" component={SettingsScreen} />
                            {/* <ProtectedRoute path="/questionScreen" component={QuestionsScreen} /> */}
                            <ProtectedRoute path="/questionScreen" component={QuestionTestScreen} />
                            <ProtectedRoute path="/singleQuestionScreen" component={SingleQuestionsScreen} />
                            {/* <ProtectedRoute path="/singleQuestionScreen" component={QuestionTestScreen} /> */}
                            <ProtectedRoute path="/createDeckScreen" component={CreateDeckScreen} />
                            <ProtectedRoute path="/editDeckScreen" component={EditDeckScreen} />
                            <ProtectedRoute path="/testResultScreen" component={CompletedTestScreen} />
                            <ProtectedRoute path="/publicDecks" component={PublicDecksScreen} />
                            <ProtectedRoute path="/viewDeck" component={ViewDeckScreen} />
                            <ProtectedRoute path="/viewMessage" component={ViewMessageScreen} /> 
                            <ProtectedRoute path="/leaderboard" component={LeaderBoardScreen} />
                            <ProtectedRoute path="/notifications" component={NotificationsScreen} />
                            <ProtectedRoute path="/program" component={ProgramScreen} />
                            <ProtectedRoute path="/residents" component={ResidentScreen} />
                            <ProtectedRoute path="/quizScreen" component={QuizScreen} />
                            <ProtectedRoute path="/quizResultScreen" component={QuizResultScreen} />
                            <ProtectedRoute path="/quizListAllScreen" component={QuizListAllScreen} />  
                            <ProtectedRoute path="/quizListScreen" component={QuizListScreen} />  
                            <Route path="/test" component={TestScreen} />
                            <Route path="/error" component={ErrorScreen} />

                            <ProtectedRoute path="*" component={ErrorScreen} />
                        </Switch>
                    </AnimatePresence>
                    <Footer />
                </Router>
            </StylesProvider>
        );
    }
}

export default Routes;